import { render, staticRenderFns } from "./we-coupon-mall.vue?vue&type=template&id=d1b82798&scoped=true"
import script from "./we-coupon-mall.vue?vue&type=script&setup=true&lang=ts"
export * from "./we-coupon-mall.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./we-coupon-mall.vue?vue&type=style&index=0&id=d1b82798&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1b82798",
  null
  
)

export default component.exports